import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const GET_CHECKLISTE_IDENTIFIER = '[VorlagenModul] GetChecklisteIdentifier laden';
export const GET_CHECKLISTE_IDENTIFIER_AUSFUEHREN = '[VorlagenModul] GetChecklisteIdentifier ausführen';
export const GET_CHECKLISTE_IDENTIFIER_ERFOLGREICH = '[VorlagenModul] GetChecklisteIdentifier laden erfolgreich';
export const GET_CHECKLISTE_IDENTIFIER_FEHLER = '[VorlagenModul] GetChecklisteIdentifier Ladefehler';
export const GET_CHECKLISTE_IDENTIFIER_NICHT_AUSGEFUEHRT = '[VorlagenModul] GetChecklisteIdentifier nicht ausgeführt (evtl. Offline)';


export class GetChecklisteIdentifierAction implements Action {
    readonly type = GET_CHECKLISTE_IDENTIFIER;
        constructor(public optPayload: any = null) {}
    }
export class GetChecklisteIdentifierAusfuehrenAction implements Action {
    readonly type = GET_CHECKLISTE_IDENTIFIER_AUSFUEHREN;
        constructor(public optPayload: any = null) {}
    }
export class GetChecklisteIdentifierErfolgreichAction implements Action {
    readonly type = GET_CHECKLISTE_IDENTIFIER_ERFOLGREICH;
        constructor(public payload: api.ChecklisteIdentifier, public optPayload: any = null) {}
    }
export class GetChecklisteIdentifierFehlerAction implements Action {
    readonly type = GET_CHECKLISTE_IDENTIFIER_FEHLER;
        constructor(public payload: any, public optPayload: any = null) {}
    }
export class GetChecklisteIdentifierNichtAusgefuehrtAction implements Action {
    readonly type = GET_CHECKLISTE_IDENTIFIER_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenQueryChecklisteIdentifierActions =
    GetChecklisteIdentifierAction
    | GetChecklisteIdentifierAusfuehrenAction
    | GetChecklisteIdentifierErfolgreichAction
    | GetChecklisteIdentifierFehlerAction
    | GetChecklisteIdentifierNichtAusgefuehrtAction
    ;
